<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12">
            <CardRh :processando="processando" titulo="Logs da Aplicação (Serilog)">

                <!--
                    Expurgo fora da faixa de filtros de propósito: é manutenção
                    destrutiva, não refinamento de consulta, e misturado aos
                    filtros convidaria ao clique por engano.
                -->
                <div v-if="podeExcluir" class="border border-danger border-dashed rounded p-4 mb-6">
                    <div class="row align-items-end">
                        <div class="col-12 col-md-5 col-xl-3">
                            <label for="dataCorte" class="form-label">Expurgar logs anteriores a</label>
                            <input id="dataCorte" v-model="data_corte" type="datetime-local" class="form-control form-control-solid"/>
                        </div>
                        <div class="col-12 col-md-4 col-xl-3 mt-4 mt-md-0">
                            <button @click="expurgar" :disabled="expurgando || !data_corte" class="btn btn-danger btn-sm">
                                {{ expurgando ? 'Expurgando...' : 'Expurgar' }}
                            </button>
                        </div>
                        <div class="col-12 col-xl-6 mt-4 mt-xl-0">
                            <span class="text-muted fs-7">
                                Apaga definitivamente todos os registros com data anterior à informada. Não há como desfazer.
                            </span>
                        </div>
                    </div>
                </div>

                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="true" @tableatualizada="tableatualizada($event)">
                    <th class="text-center" style="min-width:150px">Data</th>
                    <th class="text-center" style="min-width:110px">Nível</th>
                    <th class="text-center">Mensagem</th>
                    <th class="text-center" style="min-width:160px">Exceção</th>
                    <th class="text-center" style="min-width:140px">Ações</th>

                    <template v-slot:filtros>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                            <div class="mb-2">
                                <label for="dataMin" class="form-label">Data Mínima</label>
                                <input @keyup="apertouEnter" @blur="refreshTable" v-model="data_min" type="datetime-local" data-kt-docs-table-filter="dataMin" class="form-control form-control-solid" placeholder="Data Mínima"/>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                            <div class="mb-2">
                                <label for="dataMax" class="form-label">Data Máxima</label>
                                <input @keyup="apertouEnter" @blur="refreshTable" v-model="data_max" type="datetime-local" data-kt-docs-table-filter="dataMax" class="form-control form-control-solid" placeholder="Data Máxima"/>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                            <div class="mb-2">
                                <label for="nivel" class="form-label">Nível</label>
                                <select @change="refreshTable" data-kt-docs-table-filter="nivel" class="form-select form-select-solid">
                                    <option value="">Todos</option>
                                    <option v-for="nivel in niveis" :key="nivel" :value="nivel">{{ nivel }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                            <div class="mb-2">
                                <label for="mensagem" class="form-label">Mensagem</label>
                                <input @keyup="apertouEnter" @blur="refreshTable" type="text" data-kt-docs-table-filter="mensagem" class="form-control form-control-solid" placeholder="Mensagem"/>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2 d-flex align-items-end">
                            <div class="mb-2 w-200 d-flex gap-2">
                                <button @click="limparFiltros" class="btn btn-pmes-warning btn-sm">
                                    Limpar filtros
                                </button>
                            </div>
                        </div>
                    </template>
                </KDataTable>
            </CardRh>
        </div>
    </div>

    <div class="modal fade" id="modalDetalheSerilog" tabindex="-1" ref="modalDetalhe">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Detalhe do log</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body" v-if="detalhe">
                    <h6 class="fw-bold">Mensagem</h6>
                    <p class="texto-log">{{ detalhe.message }}</p>

                    <template v-if="detalhe.messageTemplate && detalhe.messageTemplate !== detalhe.message">
                        <h6 class="fw-bold mt-4">Template</h6>
                        <p class="texto-log">{{ detalhe.messageTemplate }}</p>
                    </template>

                    <template v-if="temPropriedades">
                        <h6 class="fw-bold mt-4">Propriedades</h6>
                        <pre class="texto-log">{{ propriedadesFormatadas }}</pre>
                    </template>

                    <template v-if="detalhe.exceptions && detalhe.exceptions.length">
                        <h6 class="fw-bold mt-4">Exceções</h6>
                        <div v-for="(excecao, idx) in detalhe.exceptions" :key="idx" class="mb-4">
                            <div class="fw-semibold">{{ excecao.className }}</div>
                            <p class="texto-log mb-2">{{ excecao.message }}</p>
                            <pre class="texto-log">{{ excecao.stackTraceString }}</pre>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import CardRh from "@/components/cards/ManzaCard.vue"
    import LogSerilogElasticService from "@/service/v1/elastic/LogSerilogElasticService"
    import { Options, Vue } from "vue-class-component";
    import KDataTable from "@/components/datatable/newdatatable.vue"
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import SiteUtils from '@/assets/ts/aplicacao/site';
    import { namespace } from 'vuex-class';
    const authStore = namespace('auth');
    import $ from 'jquery'

    @Options({
        name: "LogSerilogElastic",
        components: { CardRh, KDataTable },
    })
    export default class LogSerilogElastic extends Vue {

        @authStore.Getter
        public perfis!: any

        // Níveis fixos do Serilog; não há endpoint que os liste.
        public niveis: string[] = ['Verbose', 'Debug', 'Information', 'Warning', 'Error', 'Fatal'];

        public data_min: any = null;
        public data_max: any = null;
        public data_corte: any = null;

        public processando = false;
        public expurgando = false;
        public reloadDatatable = false;
        public detalhe: any = null;
        public config;
        public service;

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
        }

        /*
         * Excluir é só de Admin, e não Admin+ChefeSTE como a leitura: é o que a
         * API exige nos dois endpoints de exclusão. Se o botão aparecesse para
         * ChefeSTE, o clique voltaria 403.
         */
        get podeExcluir(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
        }

        get temPropriedades(): boolean {
            return !!this.detalhe && !!this.detalhe.fields && Object.keys(this.detalhe.fields).length > 0;
        }

        get propriedadesFormatadas(): string {
            return this.temPropriedades ? JSON.stringify(this.detalhe.fields, null, 2) : '';
        }

        public tableatualizada() {
            $('[btn-ver-detalhe-serilog]').off('click').on('click', (btn) => {
                const encoded = $(btn.currentTarget).attr('data-detalhe') || '';
                this.detalhe = encoded ? JSON.parse(decodeURIComponent(encoded)) : null;
            });

            $('[btn-excluir-log]').off('click').on('click', (btn) => {
                const id = $(btn.currentTarget).attr('data-id') || '';
                if (id) this.excluirLog(id);
            });
        }

        public excluirLog(id) {
            SiteUtils.alertConfimacao('Confirma a Exclusão deste log?', '',
                () => {
                    this.processando = true;
                    this.service.excluir(id)
                        .then(() => {
                            this.processando = false;
                            SiteUtils.toastSucesso('Exclusão realizada com sucesso!!');
                            this.refreshTable();
                        })
                        .catch((error) => {
                            this.processando = false;
                            SiteUtils.toastErro('Não foi possível Excluir', error?.data?.message ?? '');
                        });
                }
            );
        }

        public expurgar() {
            if (!this.data_corte) {
                SiteUtils.toastErro('Informe a data de corte do expurgo');
                return;
            }
            /*
             * A confirmação repete a data de corte em vez de só perguntar
             * "confirma?": é exclusão em lote e sem desfazer, e a data é
             * justamente o que o usuário pode ter digitado errado.
             */
            SiteUtils.alertConfimacao(
                'Excluir todos os logs anteriores a ' + SiteUtils.formatDataHora(this.data_corte) + '?',
                'Não há como desfazer.',
                () => {
                    this.expurgando = true;
                    this.service.excluirAnteriores(this.data_corte)
                        .then((response) => {
                            this.expurgando = false;
                            SiteUtils.toastSucesso(`${response?.excluidos ?? 0} registro(s) excluído(s)`);
                            this.refreshTable();
                        })
                        .catch((error) => {
                            this.expurgando = false;
                            SiteUtils.toastErro('Não foi possível Expurgar', error?.data?.message ?? '');
                        });
                }
            );
        }

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }

        public limparFiltros() {
            const limpar = (filtro: string) => {
                const el = document.querySelector(`[data-kt-docs-table-filter="${filtro}"]`) as HTMLInputElement;
                if (el) el.value = '';
            };
            limpar('mensagem');
            limpar('nivel');
            this.data_min = null;
            this.data_max = null;
            this.refreshTable();
        }

        created() {
            this.service = new LogSerilogElasticService();

            /*
             * A ordenação é sempre decrescente por data, fixada no repositório do
             * backend — o índice do Serilog é consultado com curinga e a API não
             * recebe parâmetro de ordenação. Por isso a tabela não oferece clique
             * de ordenar, que não teria efeito.
             */
            this.config = { ordering: false, ajax: {}, columns: {}, columnDefs: {} };

            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: function (d) {
                    return {
                        "Skip": d.start,
                        "Take": d.length,
                        "dataMin": () => (document.querySelector('[data-kt-docs-table-filter="dataMin"]')! as HTMLInputElement).value,
                        "dataMax": () => (document.querySelector('[data-kt-docs-table-filter="dataMax"]')! as HTMLInputElement).value,
                        "nivel": () => (document.querySelector('[data-kt-docs-table-filter="nivel"]')! as HTMLInputElement).value,
                        "mensagem": () => (document.querySelector('[data-kt-docs-table-filter="mensagem"]')! as HTMLInputElement).value,
                        "search": d.search.value
                    };
                }
            };

            this.config.columns = [
                { data: 'timestamp', name: 'timestamp', searchable: false, class: 'text-center' },
                { data: 'level', name: 'level', searchable: false, class: 'text-center' },
                { data: 'message', name: 'message', searchable: false, class: 'text-center all' },
                { data: 'exceptions', name: 'exceptions', searchable: false, class: 'text-center' },
                { data: 'id', name: 'id', searchable: false, class: 'text-center' },
            ];

            // A mensagem de log carrega conteúdo de fora (caminhos, entrada de
            // usuário, texto de exceção), então tudo que vai para o HTML da
            // tabela passa por escape.
            const escapar = (texto) => String(texto ?? '').replace(/[&<>"']/g, (c) => {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string;
            });

            /*
             * O render do DataTables é function comum, sem o this do componente;
             * a permissão entra por const capturada, como o escapar acima.
             */
            const podeExcluir = this.podeExcluir;

            const coresPorNivel = {
                Fatal: 'bg-danger', Error: 'bg-danger', Warning: 'bg-warning text-dark',
                Information: 'bg-primary', Debug: 'bg-secondary', Verbose: 'bg-secondary'
            };

            this.config.columnDefs = [
                {
                    targets: 0,
                    render: function (data) {
                        return data ? SiteUtils.formatDataHora(data) : '';
                    }
                },
                {
                    targets: 1,
                    render: function (data) {
                        if (!data) return '';
                        const cor = coresPorNivel[data] || 'bg-secondary';
                        return `<span class="badge ${cor}">${escapar(data)}</span>`;
                    }
                },
                {
                    targets: 2,
                    render: function (data) {
                        if (!data) return '';
                        const texto = escapar(data);
                        return data.length <= 140 ? texto : escapar(data.substring(0, 140)) + '...';
                    }
                },
                {
                    targets: 3,
                    render: function (data) {
                        if (!data || !data.length) return '';
                        return `<span class="text-danger">${escapar(data[0].className)}</span>`;
                    }
                },
                {
                    targets: 4,
                    render: function (data, type, row) {
                        const detalhe = encodeURIComponent(JSON.stringify({
                            message: row.message,
                            messageTemplate: row.messageTemplate,
                            fields: row.fields,
                            exceptions: row.exceptions
                        }));
                        let html = `<button class="btn btn-sm btn-link p-0" btn-ver-detalhe-serilog data-detalhe="${detalhe}" data-bs-toggle="modal" data-bs-target="#modalDetalheSerilog">Ver</button>`;
                        // O id vem do OpenSearch e vai para atributo HTML: escapa.
                        if (podeExcluir) {
                            html += `<button class="btn btn-sm btn-link text-danger p-0" btn-excluir-log data-id="${escapar(data)}">Excluir</button>`;
                        }
                        return html;
                    }
                },
            ];
        }
    }
</script>

<style scoped>
    .btn-sm {
        margin-left: 10px;
    }
    .texto-log {
        white-space: pre-wrap;
        word-break: break-word;
        font-size: 0.9rem;
    }
</style>
